import { Fragment, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Files, ShareResources } from "../../../../Constants/Constants";
import { FileTabListData } from "../../../../Data/Messenger/Messenger";
import CommonHeading from "../Common/CommonHeading";
import Document from "./Document";
import Link from "./Link";
import Media from "./Media";

const FileSection = () => {
  const [activeTab, setActiveTab] = useState("Media");

  return (
    <Fragment>
      <CommonHeading title={Files} sunTitle={ShareResources} />
      <div className="template-tab">
        <Nav tabs>
          {FileTabListData.map((item, index) => (
            <NavItem key={index}>
              <NavLink className={`button-effect ${activeTab === item ? "active" : ""}`} onClick={() => setActiveTab(item)}>
                {item}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      </div>
      <div className="file-tab">
        <TabContent activeTab={activeTab} className="custom-scroll">
          <TabPane tabId="Media">
            <Media />
          </TabPane>
          <TabPane tabId="Link">
            <Link />
          </TabPane>
          <TabPane tabId="Docs">
            <Document />
          </TabPane>
        </TabContent>
      </div>
    </Fragment>
  );
};

export default FileSection;
